class Hangman {
  constructor(word, missedGuesses) {
    this.word = word.toLowerCase().split("");
    this.missedGuesses = missedGuesses;
    this.guessedLetters = [];
    this.status = "playing";
  }

  calculateStatus() {
    let finished = true;

    this.word.forEach((letter) => {
      if (this.guessedLetters.includes(letter) || letter === " ") {
      } else {
        finished = false;
      }
    });

    if (this.missedGuesses === 0) {
      this.status = "failed";
    } else if (finished) {
      this.status = "finished";
    } else {
      this.status = "playing";
    }
  }

  get statusMessage() {
    if (this.status === "playing") {
      return `Guesses left: ${this.missedGuesses}`;
    } else if (this.status === "failed") {
      return `Nice try! the word was "${this.word.join("")}"`;
    } else {
      return `Great work! You guessed the right word`;
    }
  }

  get puzzle() {
    let puzzle = "";
    this.word.forEach((letter) => {
      if (this.guessedLetters.includes(letter) || letter === " ") {
        puzzle += letter;
      } else {
        puzzle += "*";
      }
    });
    return puzzle;
  }

  makeGuess(guess) {
    guess = guess.toLowerCase();
    const isUnique = !this.guessedLetters.includes(guess);
    const isBadGuess = !this.word.includes(guess);

    if (this.status !== "playing") {
      return;
    }

    if (isUnique) {
      this.guessedLetters.push(guess);
    }

    if (isUnique && isBadGuess) {
      this.missedGuesses--;
    }

    this.calculateStatus();
  }
}

export {Hangman as default}
